/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

export const times = [
  { key: "1200AM", text: "12:00 AM", timespan: "00:00:00" },
  { key: "1215AM", text: "12:15 AM", timespan: "00:15:00" },
  { key: "1230AM", text: "12:30 AM", timespan: "00:30:00" },
  { key: "1245AM", text: "12:45 AM", timespan: "00:45:00" },
  { key: "100AM", text: "1:00 AM", timespan: "01:00:00" },
  { key: "115AM", text: "1:15 AM", timespan: "01:15:00" },
  { key: "130AM", text: "1:30 AM", timespan: "01:30:00" },
  { key: "145AM", text: "1:45 AM", timespan: "01:45:00" },
  { key: "200AM", text: "2:00 AM", timespan: "02:00:00" },
  { key: "215AM", text: "2:15 AM", timespan: "02:15:00" },
  { key: "230AM", text: "2:30 AM", timespan: "02:30:00" },
  { key: "245AM", text: "2:45 AM", timespan: "02:45:00" },
  { key: "300AM", text: "3:00 AM", timespan: "03:00:00" },
  { key: "315AM", text: "3:15 AM", timespan: "03:15:00" },
  { key: "330AM", text: "3:30 AM", timespan: "03:30:00" },
  { key: "345AM", text: "3:45 AM", timespan: "03:45:00" },
  { key: "400AM", text: "4:00 AM", timespan: "04:00:00" },
  { key: "415AM", text: "4:15 AM", timespan: "04:15:00" },
  { key: "430AM", text: "4:30 AM", timespan: "04:30:00" },
  { key: "445AM", text: "4:45 AM", timespan: "04:45:00" },
  { key: "500AM", text: "5:00 AM", timespan: "05:00:00" },
  { key: "515AM", text: "5:15 AM", timespan: "05:15:00" },
  { key: "530AM", text: "5:30 AM", timespan: "05:30:00" },
  { key: "545AM", text: "5:45 AM", timespan: "05:45:00" },
  { key: "600AM", text: "6:00 AM", timespan: "06:00:00" },
  { key: "615AM", text: "6:15 AM", timespan: "06:15:00" },
  { key: "630AM", text: "6:30 AM", timespan: "06:30:00" },
  { key: "645AM", text: "6:45 AM", timespan: "06:45:00" },
  { key: "700AM", text: "7:00 AM", timespan: "07:00:00" },
  { key: "715AM", text: "7:15 AM", timespan: "07:15:00" },
  { key: "730AM", text: "7:30 AM", timespan: "07:30:00" },
  { key: "745AM", text: "7:45 AM", timespan: "07:45:00" },
  { key: "800AM", text: "8:00 AM", timespan: "08:00:00" },
  { key: "815AM", text: "8:15 AM", timespan: "08:15:00" },
  { key: "830AM", text: "8:30 AM", timespan: "08:30:00" },
  { key: "845AM", text: "8:45 AM", timespan: "08:45:00" },
  { key: "900AM", text: "9:00 AM", timespan: "09:00:00" },
  { key: "915AM", text: "9:15 AM", timespan: "09:15:00" },
  { key: "930AM", text: "9:30 AM", timespan: "09:30:00" },
  { key: "945AM", text: "9:45 AM", timespan: "09:45:00" },
  { key: "1000AM", text: "10:00 AM", timespan: "10:00:00" },
  { key: "1015AM", text: "10:15 AM", timespan: "10:15:00" },
  { key: "1030AM", text: "10:30 AM", timespan: "10:30:00" },
  { key: "1045AM", text: "10:45 AM", timespan: "10:45:00" },
  { key: "1100AM", text: "11:00 AM", timespan: "11:00:00" },
  { key: "1115AM", text: "11:15 AM", timespan: "11:15:00" },
  { key: "1130AM", text: "11:30 AM", timespan: "11:30:00" },
  { key: "1145AM", text: "11:45 AM", timespan: "11:45:00" },
  { key: "1200PM", text: "12:00 PM", timespan: "12:00:00" },
  { key: "1215PM", text: "12:15 PM", timespan: "12:15:00" },
  { key: "1230PM", text: "12:30 PM", timespan: "12:30:00" },
  { key: "1245PM", text: "12:45 PM", timespan: "12:45:00" },
  { key: "100PM", text: "1:00 PM", timespan: "13:00:00" },
  { key: "115PM", text: "1:15 PM", timespan: "13:15:00" },
  { key: "130PM", text: "1:30 PM", timespan: "13:30:00" },
  { key: "145PM", text: "1:45 PM", timespan: "13:45:00" },
  { key: "200PM", text: "2:00 PM", timespan: "14:00:00" },
  { key: "215PM", text: "2:15 PM", timespan: "14:15:00" },
  { key: "230PM", text: "2:30 PM", timespan: "14:30:00" },
  { key: "245PM", text: "2:45 PM", timespan: "14:45:00" },
  { key: "300PM", text: "3:00 PM", timespan: "15:00:00" },
  { key: "315PM", text: "3:15 PM", timespan: "15:15:00" },
  { key: "330PM", text: "3:30 PM", timespan: "15:30:00" },
  { key: "345PM", text: "3:45 PM", timespan: "15:45:00" },
  { key: "400PM", text: "4:00 PM", timespan: "16:00:00" },
  { key: "415PM", text: "4:15 PM", timespan: "16:15:00" },
  { key: "430PM", text: "4:30 PM", timespan: "16:30:00" },
  { key: "445PM", text: "4:45 PM", timespan: "16:45:00" },
  { key: "500PM", text: "5:00 PM", timespan: "17:00:00" },
  { key: "515PM", text: "5:15 PM", timespan: "17:15:00" },
  { key: "530PM", text: "5:30 PM", timespan: "17:30:00" },
  { key: "545PM", text: "5:45 PM", timespan: "17:45:00" },
  { key: "600PM", text: "6:00 PM", timespan: "18:00:00" },
  { key: "615PM", text: "6:15 PM", timespan: "18:15:00" },
  { key: "630PM", text: "6:30 PM", timespan: "18:30:00" },
  { key: "645PM", text: "6:45 PM", timespan: "18:45:00" },
  { key: "700PM", text: "7:00 PM", timespan: "19:00:00" },
  { key: "715PM", text: "7:15 PM", timespan: "19:15:00" },
  { key: "730PM", text: "7:30 PM", timespan: "19:30:00" },
  { key: "745PM", text: "7:45 PM", timespan: "19:45:00" },
  { key: "800PM", text: "8:00 PM", timespan: "20:00:00" },
  { key: "815PM", text: "8:15 PM", timespan: "20:15:00" },
  { key: "830PM", text: "8:30 PM", timespan: "20:30:00" },
  { key: "845PM", text: "8:45 PM", timespan: "20:45:00" },
  { key: "900PM", text: "9:00 PM", timespan: "21:00:00" },
  { key: "915PM", text: "9:15 PM", timespan: "21:15:00" },
  { key: "930PM", text: "9:30 PM", timespan: "21:30:00" },
  { key: "945PM", text: "9:45 PM", timespan: "21:45:00" },
  { key: "1000PM", text: "10:00 PM", timespan: "22:00:00" },
  { key: "1015PM", text: "10:15 PM", timespan: "22:15:00" },
  { key: "1030PM", text: "10:30 PM", timespan: "22:30:00" },
  { key: "1045PM", text: "10:45 PM", timespan: "22:45:00" },
  { key: "1100PM", text: "11:00 PM", timespan: "23:00:00" },
  { key: "1115PM", text: "11:15 PM", timespan: "23:15:00" },
  { key: "1130PM", text: "11:30 PM", timespan: "23:30:00" },
  { key: "1145PM", text: "11:45 PM", timespan: "23:45:00" },
];
export const maxDateValue = 8640000000000000;
export const minDateValue = -8640000000000000;
